import { ALERTSSTATE, SETTINGSSTATE, USERSSTATE } from '.'
import { ChangesAlerts } from '../../types'
import { SettingsType } from '../constants/enums'
import { USER_EXTENSIONS } from '../mfcLogic/ueopts'
import { playAudibleAlert } from '../mfcLogic/utilities'
import { pubSubAlerts } from './pubSub'

const HARD_LIMIT = 100

export const insertAlerts = (alerts: Array<ChangesAlerts>) => {
    const uniqueAlerts = new Map()
    const receivedAt = Date.now()
    // token balance alerts are tooltip only and are not stored
    // in the alert list or counted as unread
    const transientAlerts: Array<ChangesAlerts> = []

    alerts.forEach((alert) => {
        const { key, id } = alert

        if (key === 'tokens') {
            transientAlerts.push(alert)
            return
        }

        if (ALERTSSTATE.alerts.has(id)) {
            const { unread } = ALERTSSTATE.alerts.get(id)
            if (unread) {
                ALERTSSTATE.unread--
            }
            ALERTSSTATE.alerts.delete(id)
        }

        if (key === 'isOnline') {
            const user = USERSSTATE?.users[id]
            // console.log(
            //     '[insertAlerts]:',
            //     id,
            //     name: alert.name,
            //     user,
            //     'isOnline',
            //     USERSSTATE?.users,
            //     resolveID(id),
            //     USERSSTATE.users[id],
            // )
            const isModel = user?.isModel
            const isBookmarkedModelFriend = user?.isBookmarkedFriend
            const isModelFriend = user?.isFriendOnly

            if (
                !isModel &&
                SETTINGSSTATE[SettingsType.DEFAULT]
                    .audibleAlertNonModelFriendLogin
            ) {
                // console.log(
                //     '[insertAlerts] playing alert for',
                //     user,
                //     name: alert.name,
                //     id,
                //     'userFriendLoginSound',
                // )
                playAudibleAlert(USER_EXTENSIONS.userFriendLoginSound)
            }

            if (
                isModel &&
                isBookmarkedModelFriend &&
                SETTINGSSTATE[SettingsType.DEFAULT]
                    .audibleAlertBookmarkedModelFriendLogin
            ) {
                // console.log(
                //     '[insertAlerts] playing alert for',
                //     user,
                //     name: alert.name,
                //     id,
                //     'bookmarkedModelFriendLoginSound',
                // )
                playAudibleAlert(
                    USER_EXTENSIONS.bookmarkedModelFriendLoginSound,
                )
            }

            if (
                isModel &&
                isModelFriend &&
                SETTINGSSTATE[SettingsType.DEFAULT].audibleAlertModelFriendLogin
            ) {
                // console.log(
                //     '[insertAlerts] playing alert for',
                //     user,
                //     name: alert.name,
                //     id,
                //     'modelFriendLoginSound',
                // )
                playAudibleAlert(USER_EXTENSIONS.modelFriendLoginSound)
            }
        }

        if (
            key === 'isOnlyPrivate' ||
            key === 'isGroupShow' ||
            key === 'isTruePrivate'
        ) {
            if (
                SETTINGSSTATE[SettingsType.DEFAULT]
                    .audibleAlertModelEntersPrivateOrGroup
            ) {
                // console.log(
                //     '[insertAlerts] playing alert for',
                //     USERSSTATE?.users[id],
                //     name: alert.name,
                //     id,
                //     'modelFriendEnteredPrivateSound',
                // )
                playAudibleAlert(USER_EXTENSIONS.modelFriendEnteredPrivateSound)
            }
        }

        if (key === 'isAway' || key === 'isOffline') {
            return
        }

        ALERTSSTATE.unread++

        uniqueAlerts.set(id, { ...alert, unread: true, receivedAt })
    })

    const incomingAlerts = Array.from(uniqueAlerts)
    const existingAlerts = Array.from(ALERTSSTATE.alerts)

    ALERTSSTATE.alerts = new Map(
        [...incomingAlerts, ...existingAlerts].slice(0, HARD_LIMIT),
    )

    pubSubAlerts.emit('ALERT', {
        alerts: [
            ...incomingAlerts.map(([, alert]) => alert),
            ...transientAlerts,
        ],
        unread: ALERTSSTATE.unread,
    })

    incomingAlerts.forEach(([id, alert]) => {
        pubSubAlerts.emit('ALERT::' + id, {
            unread: ALERTSSTATE.unread,
            alerts: [alert],
        })
    })
}

export const markAlertShown = (id: number) => {
    const alert = ALERTSSTATE.alerts.get(id)
    if (alert && !alert.shownAt) alert.shownAt = Date.now()
}

export const resetUnread = () => {
    // Friends/Alerts calls this from an effect keyed on the list
    if (ALERTSSTATE.unread === 0) return
    ALERTSSTATE.alerts = new Map(
        Array.from(ALERTSSTATE.alerts).map(([id, alert]) => [
            id,
            { ...alert, unread: false },
        ]),
    )
    ALERTSSTATE.unread = 0
    pubSubAlerts.emit('ALERT', {
        alerts: [],
        unread: ALERTSSTATE.unread,
    })
}

export const clearAlerts = () => {
    ALERTSSTATE.alerts = new Map<number, ChangesAlerts>()
    ALERTSSTATE.unread = 0
    pubSubAlerts.emit('ALERT', {
        alerts: [],
        unread: ALERTSSTATE.unread,
    })
}
